/**
 * Response DTO for successful login.
 * Synchronized with backend: com.wagandroll.waggy.auth.dto.LoginResponse
 * 
 * Contains JWT token and user information.
 */
export class LoginResponse {
  constructor(data = {}) {
    this.token = data.token || '';
    this.userId = data.userId || '';
    this.name = data.name || '';
    this.email = data.email || '';
    this.tenantId = data.tenantId || '';
    this.roles = Array.isArray(data.roles) ? data.roles : (data.role ? [data.role] : []);
    this.onboardingPending = Boolean(data.onboardingPending);
  }

  /**
   * Checks if the response is valid.
   */
  isValid() {
    return Boolean(this.token && this.userId && this.email);
  }

  /**
   * Creates LoginResponse from API response.
   */
  static fromJSON(json) {
    return new LoginResponse(json);
  }
}
